module.exports = __webpack_public_path__ + "static/img/icon-default.d151b430.png";